import * as angular from "angular";
import {FacultyService} from "./faculty.service";

export const FacultyModule = angular
    .module("app.shared.faculty", [])

    .service("facultyService", FacultyService)

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/faculty/faculty.module.ts